import { School } from 'kuaidong-model'

export enum PrizeType {
  Both = 'both',
  School = 'school',
  Student = 'student',
  Teacher = 'teacher',
}

export interface IProduct {
  id: string
  url: string
  name: string
  count: number
}

export interface ISchool {
  id: string
  school: School
  products: IProduct[]
  created_time: string
}

export interface IReceiver {
  id: string
  product_name: string
  product_count: number
  product_url: string | null
  school_name: string
  teacher_name: string
  teacher_phone: string
  teacher_avatar: string
  created_time: string
  own_class_names: string[]
  products: IProduct[]
}

export interface IStudent {
  display_name: string
  class_no: number
  grade_no: number
}

export interface IShipment {
  id: string
  receiver_name: string
  receiver_phone: string
  receiver_addr: string
  deliver_company: string | null
  shipment_no: string | null
  shipped_at: string | null
  school_prizes: IShipmentPrize[]
  teacher_prizes: IShipmentPrize[]
  student_prizes: IShipmentPrize[]
}

export interface IShipmentPrize {
  product_name: string
  product_count: number
  owner: string
  receiver: string
}
